// extracted by mini-css-extract-plugin
module.exports = {"lang":"mF","langWrap":"mG","item":"mH","itemCurrent":"mI"};